"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var StudentAccountEditController = /** @class */ (function () {
    function StudentAccountEditController($state, UserService, UsersModel, FlashService, PoliciesModel) {
        var _this = this;
        this.$state = $state;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.user = UserService.getCurrentUser();
        this.submitted = false;
        this.editPassword = false;
        this.preferred_pronoun_enabled = false;
        PoliciesModel.getByID("studentmetadata").then(function (response) {
            var policyMeta = {};
            response.policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = meta.meta_value;
            });
            if (policyMeta.preferred_pronoun) {
                _this.preferred_pronoun_enabled = true;
            }
        });
        UsersModel.getStudentByID(this.user.id).then(function (response) {
            var user = Object.assign({}, response);
            if (user.usermeta.hasOwnProperty("permit")) {
                user.usermeta.permit.issuedate = (0, time_1.formatDateTime)((0, time_1.parseDate)(response.usermeta.permit.issuedate), "MM/DD/YYYY");
                user.usermeta.permit.expirationdate = (0, time_1.formatDateTime)((0, time_1.parseDate)(response.usermeta.permit.expirationdate), "MM/DD/YYYY");
            }
            user.usermeta.start_date = (0, time_1.formatDateTime)((0, time_1.parseDate)(response.usermeta.start_date), "MM/DD/YYYY");
            user.usermeta.dob = (0, time_1.formatDateTime)((0, time_1.parseDate)(response.usermeta.dob), "MM/DD/YYYY");
            _this.user = user;
        });
    }
    StudentAccountEditController.prototype.getStudentAge = function () {
        if (!this.user.hasOwnProperty("usermeta") ||
            typeof this.user.usermeta.dob === "undefined") {
            return 100;
        }
        var dob = (0, time_1.parseDate)(this.user.usermeta.dob);
        return Math.floor((0, time_1.differenceInDays)(new Date(), dob) / 365.25);
    };
    StudentAccountEditController.prototype.submit = function (isValid) {
        var _this = this;
        this.submitted = true;
        if (isValid) {
            var postData = Object.assign({}, this.user);
            postData.usermeta.formatted_drive_deadline = (0, time_1.toYMD)((0, time_1.parseDate)(this.user.usermeta.drive_deadline));
            if (this.user.usermeta.hasOwnProperty("permit")) {
                postData.usermeta.formatted_permit_issue_date = (0, time_1.toYMD)((0, time_1.parseDate)(this.user.usermeta.permit.issuedate));
                postData.usermeta.formatted_permit_expiration_date = (0, time_1.toYMD)((0, time_1.parseDate)(this.user.usermeta.permit.expirationdate));
            }
            postData.usermeta.start_date = (0, time_1.toYMD)((0, time_1.parseDate)(this.user.usermeta.start_date));
            postData.usermeta.dob = (0, time_1.toYMD)((0, time_1.parseDate)(this.user.usermeta.dob));
            postData.usermeta.receives_last_minute_text_reminders = "N";
            if (postData.usermeta.hasOwnProperty("guardian")) {
                if (!postData.usermeta.guardian.hasOwnProperty("reminders")) {
                    postData.usermeta.guardian.reminders = {
                        receives_last_minute_text_reminders: "N",
                    };
                }
                else {
                    postData.usermeta.guardian.reminders.receives_last_minute_text_reminders =
                        "N";
                }
            }
            this.UsersModel.updateStudent(postData)
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.submitted = false;
                _this.$state.go("drivecoach.student.account");
            })
                .catch(function (response) {
                _this.submitted = false;
            });
        }
        else {
            this.FlashService.setMessage({
                type: "error",
                message: "All fields are required.",
            });
        }
    };
    return StudentAccountEditController;
}());
StudentAccountEditController.$inject = [
    "$state",
    "UserService",
    "UsersModel",
    "FlashService",
    "PoliciesModel",
];
exports.default = StudentAccountEditController;
